import { useState } from "react";
import MaterialIcon from "./MaterialIcon";

interface StartPeriodProps {
  handleSubmit: (start_date: string) => void;
}

export default function StartPeriod({ handleSubmit }: StartPeriodProps) {
  let [startDate, setStartDate] = useState<string>("");

  return (
    <>
      <section className="bg-grayscale-900 shadow-grayscale-900 m-auto rounded-lg p-3 shadow">
        <h2 className="px-4 text-center font-semibold">Start Pay Period</h2>
        <p>Create a pay period to start entering activities.</p>
        <form
          className="flex flex-col"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(startDate);
          }}
        >
          <label className="mb-1 mt-2">Start date:</label>
          <input
            type="date"
            required
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-grayscale-900 rounded-lg border-2 p-2 focus:invalid:border-red-500"
            placeholder="e.g. April"
          />
          <button
            className="from-blu-200 to-blu-600 mt-4 flex items-baseline justify-center rounded-lg bg-gradient-to-tr p-2"
            type="submit"
          >
            <MaterialIcon icon="add" />
          </button>
        </form>
      </section>
    </>
  );
}
